import { render, staticRenderFns } from "./HistoryUsageWallet.vue?vue&type=template&id=583adff3"
import script from "./HistoryUsageWallet.vue?vue&type=script&lang=js"
export * from "./HistoryUsageWallet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports